import {
  formatCopAmount,
  formatSpacedPrefixCurrencyAmount,
  formatSuffixCurrencyAmount,
  formatZeroDecimalPrefixCurrencyAmount,
  usesCopAmountFormat,
  usesSpacedPrefixCurrencyFormat,
  usesSuffixCurrencyFormat,
  usesZeroDecimalPrefixCurrencyFormat,
} from '../../core/utils';

export const formatPrice = (value: number | undefined, currency?: string, currencySymbol = '$') => {
  if (usesCopAmountFormat(currency, currencySymbol)) return formatCopAmount(value, currencySymbol);
  if (usesZeroDecimalPrefixCurrencyFormat(currencySymbol)) {
    return formatZeroDecimalPrefixCurrencyAmount(value, currencySymbol);
  }
  if (usesSuffixCurrencyFormat(currencySymbol)) {
    return formatSuffixCurrencyAmount(value, currencySymbol);
  }
  if (usesSpacedPrefixCurrencyFormat(currencySymbol)) {
    return formatSpacedPrefixCurrencyAmount(value, currencySymbol);
  }
  return `${currencySymbol}${Number(value ?? 0).toFixed(2)}`;
};

export const PLAN_MONTHS: Record<string, number> = {
  monthly: 1,
  quarterly: 3,
  'semi-annually': 6,
};

// Trial plans have a PLANS duration like '3 days - month', 'week - month' or '5 days - 1 month';
// other plans have no ' - '. Unrecognised trial lengths give 0 days.
export const parseTrial = (duration = '') => {
  const [trial, renewal] = duration.split(' - ');
  if (!renewal) return null;
  const match = trial.match(/^(\d+)?\s*(day|week)s?$/);
  return {
    days: match ? Number(match[1] ?? 1) * (match[2] === 'week' ? 7 : 1) : 0,
    renewsMonthly: /^(1 )?month$/.test(renewal),
  };
};
